import axios from 'axios';

let tokenGetter: (() => Promise<string | undefined>) | null = null;

export function registerTokenGetter(fn: () => Promise<string | undefined>) {
  tokenGetter = fn;
}

// Instance created and interceptor attached at module load — no lazy init
const http = axios.create({ baseURL: import.meta.env.VITE_API_BASEURL });

http.interceptors.request.use(async (config) => {
  const token = tokenGetter ? await tokenGetter() : undefined;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default http;
